const TENANTS_NAMES = {
  intraser: 'intraser',
  acme: 'acme',
  ontruck: 'ontruck',
  xpo: 'xpo',
  rpt: 'rpt',
  cex: 'cex',
  ontime: 'ontime',
  alianza: 'alianza',
};

const HOST_LIST = {
  // Acme (test)
  [process.env.REACT_APP_ACME_LOCAL_HOST]: TENANTS_NAMES.acme,
  [process.env.REACT_APP_ACME_STAGING_HOST]: TENANTS_NAMES.acme,
  [process.env.REACT_APP_ACME_PRODUCTION_HOST]: TENANTS_NAMES.acme,
  // Ontruck
  [process.env.REACT_APP_LOCAL_HOST]: TENANTS_NAMES.ontruck,
  [process.env.REACT_APP_STAGING_HOST]: TENANTS_NAMES.ontruck,
  [process.env.REACT_APP_PRODUCTION_HOST]: TENANTS_NAMES.ontruck,
  // Intraser
  [process.env.REACT_APP_INTRASER_LOCAL_HOST]: TENANTS_NAMES.intraser,
  [process.env.REACT_APP_INTRASER_STAGING_HOST]: TENANTS_NAMES.intraser,
  [process.env.REACT_APP_INTRASER_PRODUCTION_HOST]: TENANTS_NAMES.intraser,
  // Xpo
  [process.env.REACT_APP_XPO_LOCAL_HOST]: TENANTS_NAMES.xpo,
  [process.env.REACT_APP_XPO_STAGING_HOST]: TENANTS_NAMES.xpo,
  [process.env.REACT_APP_XPO_PRODUCTION_HOST]: TENANTS_NAMES.xpo,
  // RPT
  [process.env.REACT_APP_RPT_LOCAL_HOST]: TENANTS_NAMES.rpt,
  [process.env.REACT_APP_RPT_STAGING_HOST]: TENANTS_NAMES.rpt,
  [process.env.REACT_APP_RPT_PRODUCTION_HOST]: TENANTS_NAMES.rpt,
  // CEX
  [process.env.REACT_APP_CEX_LOCAL_HOST]: TENANTS_NAMES.cex,
  [process.env.REACT_APP_CEX_STAGING_HOST]: TENANTS_NAMES.cex,
  [process.env.REACT_APP_CEX_PRODUCTION_HOST]: TENANTS_NAMES.cex,
  // OnTime
  [process.env.REACT_APP_ONTIME_LOCAL_HOST]: TENANTS_NAMES.ontime,
  [process.env.REACT_APP_ONTIME_STAGING_HOST]: TENANTS_NAMES.ontime,
  [process.env.REACT_APP_ONTIME_PRODUCTION_HOST]: TENANTS_NAMES.ontime,
  // Alianza
  [process.env.REACT_APP_ALIANZA_LOCAL_HOST]: TENANTS_NAMES.alianza,
  [process.env.REACT_APP_ALIANZA_STAGING_HOST]: TENANTS_NAMES.alianza,
  [process.env.REACT_APP_ALIANZA_PRODUCTION_HOST]: TENANTS_NAMES.alianza,
};
const HOST = HOST_LIST[window.location.host] || TENANTS_NAMES.ontruck;

const BASE_URLS = {
  [TENANTS_NAMES.acme]: process.env.REACT_APP_ACME_BASE_URL,
  [TENANTS_NAMES.intraser]: process.env.REACT_APP_INTRASER_BASE_URL,
  [TENANTS_NAMES.xpo]: process.env.REACT_APP_XPO_BASE_URL,
  [TENANTS_NAMES.ontruck]: process.env.REACT_APP_BASE_URL,
  [TENANTS_NAMES.rpt]: process.env.REACT_APP_RPT_BASE_URL,
  [TENANTS_NAMES.cex]: process.env.REACT_APP_CEX_BASE_URL,
  [TENANTS_NAMES.ontime]: process.env.REACT_APP_ONTIME_BASE_URL,
  [TENANTS_NAMES.alianza]: process.env.REACT_APP_ALIANZA_BASE_URL,
};
const BASE_URL = BASE_URLS[HOST];

//sentry displayed environment
const ENVIRONMENTS = {
  [TENANTS_NAMES.acme]: 'acme-env',
  [TENANTS_NAMES.intraser]: 'intraser-env',
  [TENANTS_NAMES.xpo]: 'xpo-env',
  [TENANTS_NAMES.rpt]: 'rpt-env',
  [TENANTS_NAMES.cex]: 'cex-env',
  [TENANTS_NAMES.ontime]: 'ontime-env',
  [TENANTS_NAMES.alianza]: 'alianza-env',
  [TENANTS_NAMES.ontruck]: process.env.REACT_APP_ENV,
};
const ENVIRONMENT = ENVIRONMENTS[HOST];

const tenantsEnvironment = {
  BASE_URL,
  ENVIRONMENT,
  AUTH_CLIENTID: process.env.REACT_APP_ONTRUCK_AUTH_CLIENTID,
};
const tenantEnv = { ...tenantsEnvironment };

export { TENANTS_NAMES, HOST, tenantEnv };
